import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  connect() {
    const options = {
      dateFormat: "Y-m-d",
      disableMobile: true,
      mode: "range",
      wrap: true,
      defaultDate: this.element.dataset.range,
    }

    const modalContent = this.element.closest(".modal-content")
    if (modalContent) {
      options.appendTo = modalContent
    }

    this.fp = flatpickr(this.element, options)
  }

  disconnect() {
    if (this.fp) {
      this.fp.destroy()
    }
  }
}
